(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcl-review-sample"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-dcl-review-prev], [data-dcl-review-next]');
  if (!control) return;
  const section = control.closest('[data-dcl-review-sample]');
  const track = section.querySelector('.dcl-review-sample__track');
  const card = track.querySelector('.dcl-review-sample__card');
  if (!card) return;
  const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
  track.scrollBy({left: control.hasAttribute('data-dcl-review-next') ? distance : -distance});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
